import React, { useContext, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useInterval } from 'react-use';
import { ANONYMOUS_HIGH_RES } from '../../constants/alert';
import { AMPLITUDE_EVENTS } from '../../constants/analytics';
import useMembershipButton from '../../hooks/useMembershipButton';
import routes from '../../routes/constants';
import text from '../../text';
import { amplitudeTrack } from '../../utilities';
import { larkiApi } from '../../utilities/api';
import { getHighResMapType } from '../../utilities/map';
import { isUserAnonymous } from '../../utilities/user';
import { MAP_TYPE, ON_REVISIT } from './constants';
import { MapViewContext } from './mapViewContext';
/**
 *  Some of the css properties are overridden
 * adding style according to Google Maps docs
 * */ var style = {
    highResButton: {
        zIndex: 3
    }
};
var SITE_ADDRESS_ENTERED = AMPLITUDE_EVENTS.SITE_ADDRESS_ENTERED;
export function EnableMetromapButton() {
    var _state_map, _state_map1;
    var buttonRef = useRef(null);
    var state = useContext(MapViewContext).state;
    var history = useHistory();
    var userProfile = useSelector(function(state) {
        return {
            userProfile: state.profileReducer.userProfile
        };
    }).userProfile;
    var handleMembershipClick = useMembershipButton().handleMembershipClick;
    var handleClick = function() {
        amplitudeTrack(SITE_ADDRESS_ENTERED.EVENT, {
            action: SITE_ADDRESS_ENTERED.CLICKED_ON_HIGH_RES
        });
        if (isUserAnonymous(userProfile)) {
            return history.push({
                pathname: routes.login,
                search: "?alertType=".concat(ANONYMOUS_HIGH_RES, "&redirectUrl=").concat(routes.order.job(state.job.id), "&onRevisit=").concat(ON_REVISIT._2D_HIGH_RES)
            });
        } else {
            if (!state.isHighResEnabled) {
                return handleMembershipClick({
                    redirectTo: {
                        path: "".concat(routes.order.root, "/").concat(state.job.id),
                        label: text('navigateToRoute', {
                            navigation: 'Back',
                            routeName: text('map2D')
                        })
                    }
                });
            }
            var mapType = getHighResMapType(state.address);
            return state.map.setMapTypeId(mapType);
        }
    };
    useInterval(function() {
        var _state_job;
        larkiApi.post('/event/high-res-map-view', {
            job_id: (_state_job = state.job) === null || _state_job === void 0 ? void 0 : _state_job.id
        });
    }, state.isHighResEnabled && ((_state_map = state.map) === null || _state_map === void 0 ? void 0 : _state_map.getMapTypeId()) === MAP_TYPE.HIGH_RES ? 60000 : null);
    return /*#__PURE__*/ React.createElement("div", {
        className: "enable-metromap-button-wrapper"
    }, /*#__PURE__*/ React.createElement("button", {
        ref: buttonRef,
        id: "high-res-button",
        className: "enable-metromap-button ".concat(state.isHighResEnabled ? "switch-to-highres-layer-button".concat(state.currentMapTypeId === MAP_TYPE.HIGH_RES || !state.currentMapTypeId && ((_state_map1 = state.map) === null || _state_map1 === void 0 ? void 0 : _state_map1.mapTypeId) === MAP_TYPE.HIGH_RES ? '-active' : '') : "start-trial-button"),
        onClick: handleClick,
        style: style.highResButton,
        title: text('highResTooltip')
    }, "High-res", !state.isHighResEnabled ? /*#__PURE__*/ React.createElement("img", {
        style: {
            margin: '0 -5px 5px 5px'
        },
        className: "icon-img",
        src: "/public/img/lock.svg",
        alt: "star"
    }) : null));
}
